<div class="container">
  <h5 class="text-center">{{ "popOutConfirmation" | translate }}
    <div class="mt-4 d-flex justify-content-around">
      <div>
        <button mat-raised-button color="primary" class="text-white" (click)="confirmDialog()">
          {{ "yes" | translate }}
        </button>
      </div>
      <div>
        <button mat-raised-button color="secondary" class="bg-red ms-2" mat-dialog-close>
          {{ "no" | translate }}

        </button>
      </div>
    </div>